export const ClearIcon = () => (
	<svg
		width="46"
		height="45"
		viewBox="0 0 46 45"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="46" height="45" rx="22.5" fill="#F2884B" />
		<line
			x1="13.5303"
			y1="12.7197"
			x2="32.0303"
			y2="31.2197"
			stroke="white"
			stroke-width="1.5"
		/>
		<line
			y1="-0.75"
			x2="26.163"
			y2="-0.75"
			transform="matrix(-0.707107 0.707107 0.707107 0.707107 33 13.25)"
			stroke="white"
			stroke-width="1.5"
		/>
	</svg>
)
export const Clock = () => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M6 3.77778V6L7.66667 7.66667M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
			stroke="#111827"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
)
export const ConfirmationIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="230"
		height="230"
		viewBox="0 0 230 230"
		fill="none"
	>
		<circle opacity="0.5" cx="115" cy="115" r="94.5" stroke="#8DE18B" />
		<circle opacity="0.2" cx="115" cy="115" r="114.5" stroke="#8DE18B" />
		<circle cx="115" cy="115" r="78" fill="#8DE18B" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M145.661 94.2887C147.446 96.007 147.446 98.793 145.661 100.511L109.09 135.711C107.304 137.43 104.41 137.43 102.625 135.711L84.3389 118.111C82.5537 116.393 82.5537 113.607 84.3389 111.889C86.1242 110.17 89.0187 110.17 90.8039 111.889L105.857 126.377L139.196 94.2887C140.981 92.5704 143.876 92.5704 145.661 94.2887Z"
			fill="white"
		/>
	</svg>
)
export const ConfirmationIcon2 = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="114"
		height="114"
		viewBox="0 0 114 114"
		fill="none"
	>
		<circle opacity="0.5" cx="57" cy="56.9991" r="46.587" stroke="#57B455" />
		<circle opacity="0.2" cx="57" cy="57" r="56.5" stroke="#57B455" />
		<circle cx="56.9997" cy="57.0007" r="38.6609" fill="#57B455" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M72.1972 46.7345C73.0821 47.5861 73.0821 48.967 72.1972 49.8187L54.0705 67.2656C53.1857 68.1173 51.751 68.1173 50.8662 67.2656L41.8028 58.5422C40.9179 57.6905 40.9179 56.3096 41.8028 55.4579C42.6877 54.6063 44.1223 54.6063 45.0072 55.4579L52.4684 62.6393L68.9929 46.7345C69.8777 45.8828 71.3124 45.8828 72.1972 46.7345Z"
			fill="white"
		/>
	</svg>
)
export const BellIcon = () => (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M14.0002 1.45898C9.00663 1.45898 4.95854 5.50708 4.95854 10.5007V11.3221C4.95854 12.1352 4.71787 12.9301 4.26686 13.6066L2.92682 15.6166C1.37154 17.9496 2.55887 21.1206 5.26389 21.8583C6.14544 22.0987 7.03443 22.3021 7.92857 22.4684L7.93079 22.4744C8.82795 24.8683 11.2258 26.5423 14.0001 26.5423C16.7745 26.5423 19.1723 24.8683 20.0695 22.4744L20.0717 22.4684C20.9659 22.3021 21.8549 22.0987 22.7365 21.8583C25.4416 21.1206 26.6289 17.9496 25.0736 15.6166L23.7336 13.6066C23.2825 12.9301 23.0419 12.1352 23.0419 11.3221V10.5007C23.0419 5.50708 18.9938 1.45898 14.0002 1.45898ZM17.9394 22.7938C15.3226 23.1064 12.6777 23.1064 10.0609 22.7938C10.8903 23.9855 12.333 24.7923 14.0001 24.7923C15.6672 24.7923 17.1099 23.9856 17.9394 22.7938ZM6.70854 10.5007C6.70854 6.47358 9.97313 3.20898 14.0002 3.20898C18.0273 3.20898 21.2919 6.47358 21.2919 10.5007V11.3221C21.2919 12.4807 21.6348 13.6133 22.2775 14.5773L23.6175 16.5874C24.5102 17.9264 23.8287 19.7465 22.2761 20.17C16.8578 21.6477 11.1426 21.6477 5.72435 20.17C4.17171 19.7465 3.49021 17.9264 4.38291 16.5874L5.72295 14.5773C6.36561 13.6133 6.70854 12.4807 6.70854 11.3221V10.5007Z"
			fill="#150901"
		/>
	</svg>
)
export const SignOut = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.46967 12.5303C5.17678 12.2374 5.17678 11.7626 5.46967 11.4697L7.46967 9.46967C7.76257 9.17678 8.23744 9.17678 8.53033 9.46967C8.82323 9.76256 8.82323 10.2374 8.53033 10.5303L7.81066 11.25L15 11.25C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75L7.81066 12.75L8.53033 13.4697C8.82323 13.7626 8.82323 14.2374 8.53033 14.5303C8.23744 14.8232 7.76257 14.8232 7.46967 14.5303L5.46967 12.5303Z"
			fill="#FFFFFF"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M13.9453 1.25H15.0551C16.4227 1.24998 17.525 1.24996 18.392 1.36652C19.2921 1.48754 20.05 1.74643 20.6519 2.34835C21.2538 2.95027 21.5127 3.70814 21.6337 4.60825C21.7503 5.47522 21.7502 6.57754 21.7502 7.94513V16.0549C21.7502 17.4225 21.7503 18.5248 21.6337 19.3918C21.5127 20.2919 21.2538 21.0497 20.6519 21.6517C20.05 22.2536 19.2921 22.5125 18.392 22.6335C17.525 22.75 16.4227 22.75 15.0551 22.75H13.9453C12.5778 22.75 11.4754 22.75 10.6085 22.6335C9.70836 22.5125 8.95048 22.2536 8.34857 21.6517C7.94963 21.2527 7.70068 20.7844 7.54305 20.2498C6.59168 20.2486 5.79906 20.2381 5.15689 20.1518C4.39294 20.0491 3.7306 19.8268 3.20191 19.2981C2.67321 18.7694 2.45093 18.1071 2.34822 17.3431C2.24996 16.6123 2.24998 15.6865 2.25 14.5537V9.44631C2.24998 8.31349 2.24996 7.38774 2.34822 6.65689C2.45093 5.89294 2.67321 5.2306 3.20191 4.7019C3.7306 4.17321 4.39294 3.95093 5.15689 3.84822C5.79906 3.76188 6.59168 3.75142 7.54305 3.75017C7.70068 3.21562 7.94963 2.74729 8.34857 2.34835C8.95048 1.74643 9.70836 1.48754 10.6085 1.36652C11.4754 1.24996 12.5778 1.24998 13.9453 1.25ZM7.25197 17.0042C7.25555 17.6487 7.2662 18.2293 7.30285 18.7491C6.46836 18.7459 5.848 18.7312 5.35676 18.6652C4.75914 18.5848 4.46611 18.441 4.26257 18.2374C4.05903 18.0339 3.91519 17.7409 3.83484 17.1432C3.7516 16.5241 3.75 15.6997 3.75 14.5V9.5C3.75 8.30029 3.7516 7.47595 3.83484 6.85676C3.91519 6.25914 4.05903 5.9661 4.26257 5.76256C4.46611 5.55902 4.75914 5.41519 5.35676 5.33484C5.848 5.2688 6.46836 5.25415 7.30285 5.25091C7.2662 5.77073 7.25555 6.35129 7.25197 6.99583C7.24966 7.41003 7.58357 7.74768 7.99778 7.74999C8.41199 7.7523 8.74964 7.41838 8.75194 7.00418C8.75803 5.91068 8.78643 5.1356 8.89448 4.54735C8.9986 3.98054 9.16577 3.65246 9.40923 3.40901C9.68599 3.13225 10.0746 2.9518 10.8083 2.85315C11.5637 2.75159 12.5648 2.75 14.0002 2.75H15.0002C16.4356 2.75 17.4367 2.75159 18.1921 2.85315C18.9259 2.9518 19.3144 3.13225 19.5912 3.40901C19.868 3.68577 20.0484 4.07435 20.1471 4.80812C20.2486 5.56347 20.2502 6.56459 20.2502 8V16C20.2502 17.4354 20.2486 18.4365 20.1471 19.1919C20.0484 19.9257 19.868 20.3142 19.5912 20.591C19.3144 20.8678 18.9259 21.0482 18.1921 21.1469C17.4367 21.2484 16.4356 21.25 15.0002 21.25H14.0002C12.5648 21.25 11.5637 21.2484 10.8083 21.1469C10.0746 21.0482 9.68599 20.8678 9.40923 20.591C9.16577 20.3475 8.9986 20.0195 8.89448 19.4527C8.78643 18.8644 8.75803 18.0893 8.75194 16.9958C8.74964 16.5816 8.41199 16.2477 7.99778 16.25C7.58357 16.2523 7.24966 16.59 7.25197 17.0042Z"
			fill="#FFFFFF"
		/>
	</svg>
)

export const ArrowRight = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M4.5 6.25C4.91421 6.25 5.25 6.58579 5.25 7C5.25 8.75556 5.96468 9.7804 6.81323 10.3913C7.70002 11.0298 8.78668 11.25 9.5 11.25L17.6893 11.25L13.9697 7.53033C13.6768 7.23744 13.6768 6.76256 13.9697 6.46967C14.2626 6.17678 14.7374 6.17678 15.0303 6.46967L20.0303 11.4697C20.3232 11.7626 20.3232 12.2374 20.0303 12.5303L15.0303 17.5303C14.7374 17.8232 14.2626 17.8232 13.9697 17.5303C13.6768 17.2374 13.6768 16.7626 13.9697 16.4697L17.6893 12.75L9.5 12.75C8.54665 12.75 7.13332 12.4702 5.93677 11.6087C4.70198 10.7196 3.75 9.24444 3.75 7C3.75 6.58579 4.08579 6.25 4.5 6.25Z"
			fill="#150901"
		/>
	</svg>
)

export const ArrowBottom = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.46967 13.9697C6.17678 14.2626 6.17678 14.7374 6.46967 15.0303L11.4697 20.0303C11.7626 20.3232 12.2374 20.3232 12.5303 20.0303L17.5303 15.0303C17.8232 14.7374 17.8232 14.2626 17.5303 13.9697C17.2374 13.6768 16.7626 13.6768 16.4697 13.9697L12.75 17.6893L12.75 9.5C12.75 8.78668 12.9702 7.70001 13.6087 6.81323C14.2196 5.96468 15.2444 5.25 17 5.25C17.4142 5.25 17.75 4.91421 17.75 4.5C17.75 4.08579 17.4142 3.75 17 3.75C14.7556 3.75 13.2804 4.70198 12.3913 5.93677C11.5298 7.13332 11.25 8.54665 11.25 9.5L11.25 17.6893L7.53033 13.9697C7.23744 13.6768 6.76256 13.6768 6.46967 13.9697Z"
			fill="#150901"
		/>
	</svg>
)

export const EyeSlash = () => (
	<svg
		width="24"
		height="25"
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.5 16.8345L17.0248 13.4382"
			stroke="white"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12 18.3345V14.8345"
			stroke="white"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M4.5 16.8345L6.96895 13.4468"
			stroke="white"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3 8.83447C6.6 16.8345 17.4 16.8345 21 8.83447"
			stroke="white"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
export const Eye = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z"
			fill="#9C9997"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z"
			fill="#9C9997"
		/>
	</svg>
)
